import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import { insertUpdatePhotographyAndVideography_action, getPhotographyAndVideographyDetails_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/photographyAndVideography_action/photographyAndVideography_action'
import $ from 'jquery'
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";

class PhotographyAndVideography extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      Is_Agree: false,
      Is_Agree2: false,
      Remark: "",
      Is_AgreeErr: "",
      Is_Agree2Err: "",
      DeadlineDate: "",
      PhotographyAndVideographyFormID: "",
      currentDate: moment().format("DD-MM-YYYY"),
      agencyList: [],
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      is_View: false,
    };

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }

  handleConfirmation(flag) {
    const { confirmationObj } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.addPhotographyAndVideography()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });

    this.getPhotographyAndVideographyDetails()
    this.loadscript()
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleCancel() {
    window.history.back()
  }

  inputValidate() {
    const { Is_Agree, Is_Agree2 } = this.state

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({ Is_AgreeErr: 'Kindly agree to request Photography And Videography' })
    }
    if (Is_Agree2 == 0 || Is_Agree2 == false) {
      this.setState({ Is_Agree2Err: 'Kindly agree to the disclaimer for Photography And Videography' })
    }
  }

  getPhotographyAndVideographyDetails() {
    this.setState({ isLoading: true })
    this.props
      .getPhotographyAndVideographyDetails_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, agencyList: data.agencyList || [] })
          if (data.data && data.data.length > 0) {
            this.setState({
              PhotographyAndVideographyFormID: data.data[0]['PhotographyAndVideographyFormID'],
              Is_Agree: data.data[0]['IsRequiredPhotographyAndVideography'],
              Is_Agree2: data.data[0]['IsAgree'],
              Remark: data.data[0]['Remark'],
            })
          }
        }
        else {
          this.setState({ isLoading: false })
          toastError(data.msg)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addPhotographyAndVideography() {
    const { Remark, Is_Agree, PhotographyAndVideographyFormID, Is_Agree2, StatusID } = this.state
    this.inputValidate()
    this.setState({ isLoading: true })
    if (Is_Agree && Is_Agree2) {
      const ManualFormsID = this.props.location.state?.ManualFormsID || null;
      const ServiceID = this.props.location.state?.ServiceID || null;
      const VendorDetails = this.props.location.state?.VendorDetails || {};
      this.props
        .insertUpdatePhotographyAndVideography_action(
          PhotographyAndVideographyFormID,
          Is_Agree,
          Remark,
          Is_Agree2,
          ManualFormsID,
          ServiceID,
          VendorDetails,
          1,
          false
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            toastSuccess(
              this.state.StatusID == 0
                ? "Photography And Videography Form Submitted Successfully"
                : "Photography And Videography Form Updated Successfully"
            );
            setTimeout(() => {
              this.props.navigate("/manualForms");
            }, 2000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toastError("Please Enter mandatory fields!")
      this.inputValidate()
      this.setState({ isLoading: false })
    }
  }

  renderAgencyCard(agency, index) {
    return (
      <div
        key={index}
        style={{
          backgroundColor: "#ebebeb",
          marginBottom: "14px",
          borderRadius: "4px",
          border: "1px solid lightgray",
          overflow: "hidden",
        }}
      >
        <div style={{ padding: "10px 14px", borderBottom: "1px solid #d0d0d0" }}>
          <p className="m-0 mb-1"><strong style={{ color: "#444" }}>Agency Details</strong></p>
          {agency.AgencyName && <p className="m-0"><strong>Agency Name:</strong> {agency.AgencyName}</p>}
          {agency.Designation && <p className="m-0"><strong>Designation:</strong> {agency.Designation}</p>}
          {agency.Telephone && <p className="m-0"><strong>Telephone:</strong> {agency.Telephone}</p>}
          {agency.Mobile && <p className="m-0"><strong>Mobile:</strong> {agency.Mobile}</p>}
          {agency.Fax && <p className="m-0"><strong>Fax:</strong> {agency.Fax}</p>}
          {agency.Email && <p className="m-0"><strong>Email:</strong> {agency.Email}</p>}
          {agency.PANNo && <p className="m-0"><strong>PAN No:</strong> {agency.PANNo}</p>}
          {agency.GSTNo && <p className="m-0"><strong>GST No:</strong> {agency.GSTNo}</p>}
        </div>

        {(agency.BankName || agency.BranchName || agency.AccountNo || agency.BeneficiaryName ||
          agency.BeneficiaryAddress || agency.SwiftCode || agency.RTGSIFSCCode) && (
          <div style={{ padding: "10px 14px" }}>
            <p className="m-0 mb-1"><strong style={{ color: "#444" }}>Bank Details</strong></p>
            {agency.BankName && <p className="m-0"><strong>Bank Name:</strong> {agency.BankName}</p>}
            {agency.BranchName && <p className="m-0"><strong>Branch Name:</strong> {agency.BranchName}</p>}
            {agency.AccountNo && <p className="m-0"><strong>Account No:</strong> {agency.AccountNo}</p>}
            {agency.BeneficiaryName && <p className="m-0"><strong>Beneficiary Name:</strong> {agency.BeneficiaryName}</p>}
            {agency.BeneficiaryAddress && <p className="m-0"><strong>Beneficiary Address:</strong> {agency.BeneficiaryAddress}</p>}
            {agency.SwiftCode && <p className="m-0"><strong>SWIFT Code:</strong> {agency.SwiftCode}</p>}
            {agency.RTGSIFSCCode && <p className="m-0"><strong>RTGS/IFSC Code:</strong> {agency.RTGSIFSCCode}</p>}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { isLoading, Is_Agree, isOpenConfirmationModal, Remark, Is_AgreeErr, currentDate, DeadlineDate, Is_Agree2, Is_Agree2Err, agencyList, StatusID, isHideSection, is_View } = this.state
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="exb-top-space">
              <div className="row">
                <div class="card rounded-0 pt-1 shadow-none">
                  <div class="card-header p-2" style={{ paddingleft: "7px !important" }}>
                    <h3 class="card-title" style={{ fontsize: "15px", paddingTop: "5px" }}>
                      Photography And Videography
                    </h3>
                  </div>
                  <div class="card-body p-1 m-2">
                    {!isHideSection && (
                      <ul style={{ lineHeight: "25px", textAlign: "left", padding: 0 }}>
                        <li><strong>Disclaimer</strong></li>
                        <li>
                          1) The cost/rates and terms & conditions of utilizing the individual
                          services from the given service provider is solely discretion of
                          exhibitors.
                        </li>
                        <li>
                          2) India ITME Society is only information facilitator for the service
                          provider & In no event shall INDIA ITME SOCIETY be liable for any
                          direct, indirect, punitive, incidental, special consequential issues,
                          whatsoever arising out of taking services with the above given service
                          provider.
                        </li>
                      </ul>
                    )}
                    {!isHideSection && (
                      <div className="row mt-4">
                        <h6 className="mt-2">
                          Photography And Videography{" "}
                          <span className="text-danger">
                            {" "}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )}
                    {agencyList && agencyList.length > 0 && (
                      <>
                        <strong>
                          <p className="m-0 mt-2 mb-2">Photography And Videography Details:-</p>
                        </strong>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "14px" }}>
                          {agencyList.map((agency, index) => (
                            <div key={index} style={{ width: "calc(50% - 7px)", minWidth: "300px" }}>
                              {this.renderAgencyCard(agency, index)}
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div class="row m-1">
                  <form>
                    <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                      <input
                        type="checkbox"
                        checked={Is_Agree}
                        disabled={isDeadlinePassed || is_View}
                        onChange={(e) =>
                          this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })
                        }
                      />
                      <strong>&nbsp;I want to request Photography And Videography.</strong>
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_AgreeErr}
                      </span>
                    }
                    <strong>
                      {" "}
                      <label>Additional Note</label>{" "}
                    </strong>
                    <textarea
                      class="form-control"
                      value={Remark}
                      onChange={(e) => this.setState({ Remark: e.target.value })}
                      disabled={isDeadlinePassed || is_View}
                      maxLength={300}
                      rows="3"
                    ></textarea>
                    <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                      <input
                        type="checkbox"
                        checked={Is_Agree2}
                        disabled={isDeadlinePassed || is_View}
                        onChange={(e) =>
                          this.setState({ Is_Agree2: e.target.checked, Is_Agree2Err: "" })
                        }
                      />
                      <strong>
                        &nbsp;I agree the above disclaimer for Photography And Videography
                        <span className="required">*</span>.
                      </strong>
                    </label>
                    {
                      <span className="text-danger text-start text-left d-block mt-1">
                        {Is_Agree2Err}
                      </span>
                    }
                  </form>
                </div>
              </div>
              {!isHideSection && (
                <div className="row">
                  {isDeadlinePassed && (
                    <span className="text-danger">
                      THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                    </span>
                  )}
                </div>
              )}
              {!isHideSection && (
                <div class="d-flex justify-content-end mt-0">
                  <button
                    type="button"
                    className="btn btn-aqua rounded-1 d-block"
                    style={{ marginRight: 10 }}
                    disabled={currentDate > DeadlineDate}
                    onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                  >
                    {this.state.StatusID == 0 ? "Submit" : "Update"}
                  </button>
                  <button
                    className="btn btn-gray rounded-1 d-block"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(null, { insertUpdatePhotographyAndVideography_action, getPhotographyAndVideographyDetails_action })(PhotographyAndVideography));
